import en from './en.json'
import it from './it.json'

export const peopleTranslations = {
	en,
	it
} as const
